import axios from "axios";

// get products by category
export const getProductsdetail = async (productId) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/products-handler/?product_id=${productId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching products-detail:", error);
    throw error;
  }
};